import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'users',
});

export const userCreateRouteRef = createSubRouteRef({
  id: "create",
  parent: rootRouteRef,
  path: '/create',
});